import { useEffect, useState } from 'react'

/**
 * A clock that ticks once a minute, and immediately whenever the page becomes
 * visible again.
 *
 * The visibility half matters more than the interval: a phone that has been in a
 * pocket for two hours resumes with a stale timer, and the day view would otherwise
 * show the wrong concert as playing until the next tick.
 */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const tick = () => setNow(new Date())
    const id = window.setInterval(tick, intervalMs)

    function onVisibilityChange() {
      if (document.visibilityState === 'visible') tick()
    }
    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      window.clearInterval(id)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [intervalMs])

  return now
}
